import { OverlayCloseButton, type OverlayCloseButtonProps } from '../Overlay';

export type PopoverCloseButtonProps = Omit<OverlayCloseButtonProps, 'label'> & { label?: string };

/**
 * Close button to be used within a Popover.
 */
export function PopoverCloseButton(props: PopoverCloseButtonProps) {
    return (
        <OverlayCloseButton
            {...props}
            label={props.label ?? 'Cancel'}
            kind={props.kind ?? 'secondary'}
        />
    );
}
